import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {Modal} from "../../../components/modal/Modal";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {cplUnsubscribeUser} from "../api/cpl_unsubscribe_user";
import {ActivitySource} from "../constants/ActivitySource";

export const CplUnsubscribeView = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const params = useParams<{uuid: string; site: keyof typeof ActivitySource}>();

    const {shouldModalBeOpened: showModal, closeModal} = useModal({openedByDefault: true});
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // Only `rynekpierwotny` site param should be handled
        const allowedSite = params.site && params.site === SiteSlug.RP;

        allowedSite ? setLoading(false) : pushToHomePage();
    }, []);

    const onUnsubscribe = () => {
        cplUnsubscribeUser(params.uuid)
            .then(() => closeModal())
            .catch(() => dispatch(addNotification(defaultAPIErrorNotification)));
    };

    const pushToHomePage = () => {
        history.push(kmAppLink.site.baseWithParams({site: SiteSlug.KM}));
    };

    if (loading) return <FullPageLoader />;

    return (
        <div>
            <Container>
                {showModal ? (
                    <FullPageLoader />
                ) : (
                    <CenterBox className={minHeightStyle}>
                        <Text variant="headline_0" mb={2}>
                            Przykro nam, że nas opuszczasz
                        </Text>
                        <Text variant="body_copy_0">Szanujemy Twoje zdanie - nie będziemy już wysyłać rekomendacji na Twój na adres e-mail.</Text>
                    </CenterBox>
                )}
            </Container>

            <Modal isOpen={showModal} onModalClose={pushToHomePage} className={modalStyle}>
                <Modal.Layout.ConfirmCentered
                    title="Czy na pewno chcesz usunąć swój adres e‑mail z naszej bazy rekomendacji?"
                    onConfirmation={onUnsubscribe}
                    onCancel={pushToHomePage}
                    okButtonText="Tak"
                    cancelButtonText="Nie"
                />
            </Modal>
        </div>
    );
};

const minHeightStyle = css({
    minHeight: "100vh"
});

const modalStyle = css({
    md: {
        maxWidth: "66rem"
    }
});
import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {Modal} from "../../../components/modal/Modal";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {cplUnsubscribeUser} from "../api/cpl_unsubscribe_user";
import {ActivitySource} from "../constants/ActivitySource";

export const CplUnsubscribeView = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const params = useParams<{uuid: string; site: keyof typeof ActivitySource}>();

    const {shouldModalBeOpened: showModal, closeModal} = useModal({openedByDefault: true});
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // Only `rynekpierwotny` site param should be handled
        const allowedSite = params.site && params.site === SiteSlug.RP;

        allowedSite ? setLoading(false) : pushToHomePage();
    }, []);

    const onUnsubscribe = () => {
        cplUnsubscribeUser(params.uuid)
            .then(() => closeModal())
            .catch(() => dispatch(addNotification(defaultAPIErrorNotification)));
    };

    const pushToHomePage = () => {
        history.push(kmAppLink.site.baseWithParams({site: SiteSlug.KM}));
    };

    if (loading) return <FullPageLoader />;

    return (
        <div>
            <Container>
                {showModal ? (
                    <FullPageLoader />
                ) : (
                    <CenterBox className={minHeightStyle}>
                        <Text variant="headline_0" mb={2}>
                            Przykro nam, że nas opuszczasz
                        </Text>
                        <Text variant="body_copy_0">Szanujemy Twoje zdanie - nie będziemy już wysyłać rekomendacji na Twój na adres e-mail.</Text>
                    </CenterBox>
                )}
            </Container>

            <Modal isOpen={showModal} onModalClose={pushToHomePage} className={modalStyle}>
                <Modal.Layout.ConfirmCentered
                    title="Czy na pewno chcesz usunąć swój adres e‑mail z naszej bazy rekomendacji?"
                    onConfirmation={onUnsubscribe}
                    onCancel={pushToHomePage}
                    okButtonText="Tak"
                    cancelButtonText="Nie"
                />
            </Modal>
        </div>
    );
};

const minHeightStyle = css({
    minHeight: "100vh"
});

const modalStyle = css({
    md: {
        maxWidth: "66rem"
    }
});
